import { DashboardContext } from '../../../contexts/states/DashboardState';
import { useContext, useState, useEffect } from 'react';

export const InputForm = ({ type, placeholder, id }) => {
  const [txtValue, setTxtValue] = useState('');
  const [txtValue2, setTxtValue2] = useState('');
  const [error, setError] = useState(false);
  const {
    loading,
    changePassword,
    changeCarPrice,
    globalError,
    setGlobalError,
  } = useContext(DashboardContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!txtValue && type === 'text') {
      return setError('Input field must not be empty');
    }

    if (type === 'password') {
      if (!txtValue || !txtValue2) return setError('Both fields are required');
      if (txtValue2.length <= 8)
        return setError('Password should be longer than 8');

      return changePassword(txtValue, txtValue2);
    }

    changeCarPrice(id, txtValue);
    setTxtValue('');
    setTxtValue2('');
  };

  const makePasswordVisible = (e) => {
    const input = e.target.previousElementSibling;

    if (input.type === 'password') {
      input.type = 'text';
    } else {
      input.type = 'password';
    }
  };

  useEffect(() => {
    let t;
    if (globalError || error) {
      t = setTimeout(() => {
        setGlobalError(false);
        setError(false);
      }, 3000);
    }

    return () => clearTimeout(t);

    // eslint-disable-next-line
  }, [globalError, error]);

  return (
    <form onSubmit={handleSubmit}>
      <div className='fields'>
        <div>
          <div className='input-field'>
            <input
              type={type}
              placeholder={placeholder}
              value={txtValue}
              id={id}
              onChange={(e) => setTxtValue(e.target.value)}
            />

            {type === 'password' && <p onClick={makePasswordVisible}>See</p>}
          </div>

          {type === 'password' && (
            <div className='input-field'>
              <input
                type='password'
                placeholder='Enter new password'
                value={txtValue2}
                id={id}
                onChange={(e) => setTxtValue2(e.target.value)}
              />

              <p onClick={makePasswordVisible}>See</p>
            </div>
          )}
        </div>
        <input
          type='submit'
          value={loading ? 'loading...' : 'Save'}
          onClick={handleSubmit}
          disabled={loading}
        />
      </div>
      {error && <p className='error'>{error}</p>}
      {globalError && <p className='error'>{globalError}</p>}
    </form>
  );
};

// TODO: make money while singing
// * a new todo
// ? let's see what we have
